export const patientListInitialData = {
  allOrganizations: [
    {
      text: 'Test Medical Center',
      value: 1,
    },
    {
      text: 'Test Center',
      value: 2,
    },
  ],
  allPrograms: [
    {
      text: 'Core 12 Month Program',
      value: 1,
    },
  ],
  allProviders: [
    {
      text: 'Test prov',
      value: 4,
    },
  ],
  tableParams: {
    columns: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12, 14, 15, 16, 17, 13, 18, 11],
    filters: {
      status: [],
      markers: [],
      providers: [],
    },
    perPage: 100,
    sorting: {
      sortBy: 'firstName',
      sortDirection: 'ASC',
    },
  },
};
export const patientListData = {
  total: 2,
  data: [
    {
      patient: {
        id: 4,
        patientId: 200,
        firstName: 'Patient',
        lastName: 'P.',
        name: 'Patient  P. ',
        lastContact: '2021-04-12T13:32:47.912Z',
        mobilePhone: '+16505130515',
        birthDate: '1946-09-05',
        homePhone: '2525252525',
        lastLogin: '2021-04-10T13:32:47.912Z',
      },
      email: 'patient_p@evolve.com',
      status: 'Active',
      baseline_weight: null,
      last_weight: {
        weight: 120,
        date: '2021-04-20T13:50:00.000Z',
      },
      last_weight_device: null,
      weight_change: {
        changed: -0.64,
        decreased: true,
      },
      last_contact: '2021-07-12T13:32:47.912Z',
      tags: [
        {
          name: 'tag1',
          id: 1,
          organizationId: null,
        },
        {
          name: 'Org Tag',
          id: 5,
          organizationId: 8,
        },
      ],
      providers: [
        {
          id: 41,
          name: 'Test Prov',
          specialities: ['Cardiology', 'Nephrology', 'Diabetes'],
        },
      ],
      organization: {
        name: 'Test Medical Center',
        id: 8,
      },
      program: {
        name: 'Core 12 Month Program',
        id: 1,
      },
      ehr_identifiers: [
        //
        {
          ehrPlatform: 'Redox Dev Tools',
          identifier: '00000005651',
          identifierType: 'MRH',
          id: 13,
        },
      ],
      isTestUser: false,
    },
    {
      patient: {
        id: 3,
        patientId: 200,
        firstName: 'Patient',
        lastName: '2',
        name: 'Patient 2',
        lastContact: '2021-01-12T13:32:47.912Z',
        mobilePhone: '+16506490512',
        birthDate: '1966-02-08',
        homePhone: '2589025252',
        lastLogin: '2021-05-10T13:32:47.912Z',
      },
      email: 'patient_2@evolve.com',
      status: 'Inactive',
      baseline_weight: {
        weight: 200,
        date: '2020-05-08T17:53:25.280Z',
      },
      last_weight: {
        weight: 250,
        date: '2020-02-08T17:53:25.280Z',
      },
      last_weight_device: null,
      weight_change: null,
      last_contact: '2021-04-12T13:32:47.912Z',
      tags: null,
      providers: [
        {
          id: 22,
          name: 'Nicole Smith',
          specialities: ['Nephrology'],
        },
        {
          id: 30,
          name: 'Roberta Debois',
          specialities: ['Internal Medicine'],
        },
        {
          id: 32,
          name: 'Scott Stagonovich',
          specialities: ['Obesity'],
        },
        {
          id: 34,
          name: 'Stephen Bailey',
          specialities: ['Cardiology'],
        },
      ],
      organization: {
        name: 'Test Center',
        id: 8,
      },
      program: {
        name: 'Core 6 Month Program',
        id: 1,
      },
      ehr_identifiers: null,
      isTestUser: true,
    },
  ],
};

export const tag = {
  id: 1,
  tagId: 28,
  ownerId: 1,
  patientId: 1790,
  createdBy: 1,
  updatedBy: 1,
  updatedAt: '2021-08-05T12:43:03.356Z',
  createdAt: '2021-08-05T12:43:03.356Z',
};
